/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} TaglineInputs */

const en_tagline = /** @type {(inputs: TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Humans and AI agents work as one team, all the way to done.`)
};

const id_tagline = /** @type {(inputs: TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tim dan agen AI bekerja bersama, sampai tuntas.`)
};

/**
* | output |
* | --- |
* | "Humans and AI agents work as one team, all the way to done." |
*
* @param {TaglineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tagline = /** @type {((inputs?: TaglineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<TaglineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tagline(inputs)
	return en_tagline(inputs)
});